import React from "react";
import { version } from "../../../../package.json";
import BottomFooter from "./BottomFooter";
import ContactFooter from "./ContactFooter";
import FooterLinks from "./FooterLinks";
import FooterBadges from "./FooterBadges";
import { COMPANY_LINKS, SERVICES_LINKS } from "@/data/linksData";
import Logo from "../../logo/Logo";
import { WEBSITE_DETAILS } from "@/config";

const TheFooter = () => {
  return (
    <footer className="bg-gray-900 py-12 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand + Badges */}
          <div className="footer-column">
            <div className="mb-3">
              <Logo />
            </div>
            <p className="mb-4 text-gray-300">{WEBSITE_DETAILS.description}</p>
            <FooterBadges />
          </div>

          {/* Services */}
          <FooterLinks title="Services" links={SERVICES_LINKS} />

          {/* Company */}
          <FooterLinks title="Company" links={COMPANY_LINKS} />

          {/* Contact Info */}
          <div className="footer-column">
            <ContactFooter />
          </div>
        </div>

        {/* Bottom Bar */}
        <div>
          <BottomFooter version={version} />
        </div>
      </div>
    </footer>
  );
};

export default TheFooter;
